import { render } from "./FooterLinks.vue?vue&type=template&id=75a345d2&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"

import "./FooterLinks.vue?vue&type=style&index=0&id=75a345d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a345d2"]])

export default __exports__